import React from 'react';
import { I18n } from '../../../helpers/i18n';
import { formatRating } from '../../../helpers/utils';
import starInactive from '../../../static/images/mvp/star_in_active.png';
import starActive from '../../../static/images/mvp/star_active.png';
import './TotalRatingsComponent.css';

function TotalRatingsComponent({
  totalPointEvaluating = 0,
  totalEvaluating = 0,
  onClick,
  style = {},
  isSmallStar = false,
  isOnCardTopic = false,
}) {
  if (isOnCardTopic) {
    return (
      <span className="total-ratings-clickable" onClick={onClick} style={style}>
        <img
          src={totalEvaluating > 0 ? starActive : starInactive}
          className={`total-ratings-star-image ${isSmallStar ? 'small' : ''}`}
          alt="rating"
        />
        {totalEvaluating > 0 ? (
          <>
            <span className="total-ratings-points-text">{formatRating(totalPointEvaluating)}</span>
            <span className="total-ratings-count no-underline">({totalEvaluating.toLocaleString()})</span>
          </>
        ) : (
          <span className="total-ratings-none">{I18n.t('no_rating')}</span>
        )}
      </span>
    );
  }

  return (
    <span className="total-ratings-clickable" onClick={onClick} style={style}>
      <img src={starInactive} className={`total-ratings-star-image ${isSmallStar ? 'small' : ''}`} alt="rating" />
      {totalEvaluating > 0 ? (
        <>
          <span className="total-ratings-points-text">{formatRating(totalPointEvaluating)}</span>
          <span className="total-ratings-count">
            ({totalEvaluating.toLocaleString()} {I18n.t('ratings_count')})
          </span>
        </>
      ) : (
        <span className="total-ratings-none">{I18n.t('no_rating')}</span>
      )}
    </span>
  );
}

export default TotalRatingsComponent;
